module.exports = __webpack_public_path__ + "static/img/bill.faccaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/bill.png
// module id = fo+q
// module chunks = 0